import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction, ApplicationState } from './';

export type TabsState = { [key: string]: TabState };

export interface TabState {
    selectedTab: string;
}

interface SelectTab { type: "SELECT_TAB"; namespace: string; name: string }
interface ResetTabs { type: "RESET_TABS"; namespace: string; }

type KnownAction = SelectTab | ResetTabs;

export const actionCreators = {
    selectTab: (namespace: string, name: string) => <SelectTab>{ type: "SELECT_TAB", namespace: namespace, name: name }
}

const unloadedState: TabsState = {

};

export const reducer: Reducer<TabsState> = (state: TabsState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "SELECT_TAB":
            return {
                ...state,
                [action.namespace]: {
                    ...state[action.namespace],
                    selectedTab: action.name
                }
            };
        case "RESET_TABS":
            return {
                ...state,
                [action.namespace]: {
                    ...state[action.namespace],
                    selectedTab: undefined
                }
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};
